"use client";

import { useEffect } from "react";
import { reportError } from "@/lib/error-reporting/report-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError({
      error,
      source: "react_global_error",
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="ja">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 16px",
          backgroundColor: "#FDFCFB",
          fontFamily:
            "'Plus Jakarta Sans', 'Hiragino Kaku Gothic ProN', 'Yu Gothic', sans-serif",
        }}
      >
        <div style={{ maxWidth: "384px", width: "100%", textAlign: "center" }}>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error はルートレイアウト外で動作するため next/link が使用できない */}
          <a
            href="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
              marginBottom: "16px",
              textDecoration: "none",
            }}
          >
            <img
              src="/logo_menren.svg"
              alt="MENREN"
              style={{ height: "40px", width: "auto" }}
            />
          </a>
          <h1
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "#2C1A1E",
              margin: "0 0 8px",
            }}
          >
            エラーが発生しました
          </h1>
          <p
            style={{
              fontSize: "14px",
              color: "#8C6B72",
              lineHeight: 1.6,
              margin: "0 0 24px",
            }}
          >
            一時的な問題が発生しました。
            <br />
            しばらくしてからもう一度お試しください。
          </p>
          <button
            onClick={reset}
            style={{
              display: "inline-block",
              backgroundColor: "#F67A50",
              color: "#3D1F25",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 500,
              border: "none",
              cursor: "pointer",
              marginBottom: "12px",
              width: "100%",
            }}
          >
            もう一度試す
          </button>
          <br />
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error はルートレイアウト外で動作するため next/link が使用できない */}
          <a
            href="/"
            style={{
              fontSize: "14px",
              color: "#F67A50",
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            ホームに戻る
          </a>
        </div>
      </body>
    </html>
  );
}
